import { combineReducers } from 'redux';
import { reducer as responsive } from 'react-responsive-redux';

import user from './authReducer';
import flights from './FlightsUiReducer';
import reviewsState from './reviewsReducer';
import ratingsState from './ratingsReducer';

const rootReducer = combineReducers({
  flights,
  user,
  responsive,
  reviewsState,
  ratingsState,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js